import './accountCard.scss';
import React from 'react';
import { useContext } from 'react';
import { AppContext } from '../../../../context/appContext';
import UserAvatar from '../../../../common/businessCommon/user/userAvatar/userAvatar';
import UserName from '../../../../common/businessCommon/user/userName/userName';
import { getAccountName } from '../../../../services/authorizationService';
import { openWindow } from '@umu/umu-dom';
import { USEQuery } from '@umu/umu-util';
import LangCache from '../../../../base/langCache';
import { isEnterprise } from '../../../../utils/util';
export function AccountCard() {
    const { state } = useContext(AppContext);
    const { userInfo, isInUSE, isInAITools, totalPoints, enterpriseInfo } = state;
    const accountDisplayName = getAccountName(userInfo);
    const LANG = LangCache.getLang();
    const isEnterpriseAccount = isEnterprise(enterpriseInfo.enterprise_id);

    const handleClickAccountCard = () => {
        isInUSE && openWindow(`/profile?${USEQuery}=1&headerType=2#/profile`);
    };

    return (
        <div className="account-card" onClick={handleClickAccountCard}>
            <div className="account-card-avatar">
                <UserAvatar
                    src={userInfo.avatar}
                    className="data-user-avatar"
                    width={70}
                    showUserLevel={isInUSE || isInAITools ? 0 : userInfo.show_user_level}
                    userLevelInfo={userInfo.user_level}
                />
            </div>
            <div className="account-card-info">
                <div className="info-name truncate-text">
                    <UserName
                        name={userInfo.user_name}
                        className="data-user-name"
                        userMedalInfo={userInfo.user_medal}
                        showUserLevel={isInUSE || isInAITools ? 0 : userInfo.show_user_level}
                        transcate={true}
                    />
                </div>
                <div className="info-display-name truncate-text">{accountDisplayName}</div>
                {!!isInAITools && !isEnterpriseAccount && (
                    <div className="info-display-points truncate-text">
                        <span className="info-display-points-text">{LANG['当前可用点数：']}</span>
                        <span className="info-display-points-value">{totalPoints}</span>
                    </div>
                )}
            </div>
        </div>
    );
}
